<ul>
  @if (employee.totalActionsRequired() > 0 && !is_meeting_mode_enabled()) {
    <li>
      <a
        matRipple
        class="menu-link-alert menu-link-alert--danger"
        role="button"
        tabindex="0"
        (click)="openFirstPendingAction($event)"
        (keydown.enter)="openFirstPendingAction($event)"
      >
        <mat-icon>notifications</mat-icon>
        <span
          >{{ employee.totalActionsRequired() }}
          {{ employee.totalActionsRequired() === 1 ? 'acción pendiente' : 'acciones pendientes' }}</span
        >
      </a>
    </li>
  }

  @if (platform.isElectronApp() && platform.newVersionAvailable()) {
    <li>
      <a
        matRipple
        class="menu-link-alert"
        role="button"
        tabindex="0"
        (click)="openUpdateDialog()"
        (keydown.enter)="openUpdateDialog()"
        style="color: var(--blue_color)"
      >
        <mat-icon>system_update</mat-icon>
        <span>Actualización disponible</span>
      </a>
    </li>
  }

  <li routerLinkActive="active">
    <a matRipple [routerLink]="['/employees', 'dashboard']">
      <mat-icon>home</mat-icon>
      <span>Dashboard</span>
    </a>
  </li>

  @if (canSeeProjectsSection()) {
    @if (employee.meetingModeEnabled | async) {
      @if ((employee.meetingModeCompanyProduct | async) && company_product) {
        <li routerLinkActive="active">
          <a matRipple [routerLink]="['/employees', 'development', 'company-products', company_product.id]">
            <div class="d-flex">
              <div class="company-product-logo" [ngStyle]="{ 'background-image': 'url(' + company_product.logo_url + ')' }"></div>
              <div class="company-product-menu-content">
                <span>{{ company_product.title }}</span>
                @if (active_objective_title_by_company_product_id()[company_product.id]; as objective_title) {
                  <app-truncated-text-marquee class="company-product-active-objective" [text]="objective_title" />
                }
              </div>
            </div>
          </a>
        </li>
      }
    } @else if (has_multiple_company_products()) {
      <li
        class="menu-separator menu-accordion-header"
        matRipple
        role="button"
        tabindex="0"
        [class.section-active]="isSectionActive(MenuSectionEnum.COMPANY_PRODUCTS)"
        [attr.aria-expanded]="isSectionExpanded(MenuSectionEnum.COMPANY_PRODUCTS)"
        (click)="toggleSection(MenuSectionEnum.COMPANY_PRODUCTS)"
        (keydown)="onAccordionKeydown($event, MenuSectionEnum.COMPANY_PRODUCTS)"
      >
        <span>Productos</span>
        <mat-icon class="menu-accordion-chevron" [class.expanded]="isSectionExpanded(MenuSectionEnum.COMPANY_PRODUCTS)"
          >expand_more</mat-icon
        >
      </li>
      @if (isSectionExpanded(MenuSectionEnum.COMPANY_PRODUCTS)) {
        @for (company_product_item of company_products_list(); track company_product_item.company_product_id) {
          <li [class.active]="isCompanyProductActive(company_product_item.company_product_id)">
            <a
              matRipple
              role="button"
              tabindex="0"
              (click)="goToCompanyProductPhases(company_product_item.company_product_id)"
              (keydown.enter)="goToCompanyProductPhases(company_product_item.company_product_id)"
            >
              <div
                class="company-product-logo"
                [ngStyle]="{ 'background-image': 'url(' + company_product_item.company_product_logo_url + ')' }"
              ></div>
              <div class="company-product-menu-content">
                <span>{{ company_product_item.company_product_name }}</span>
                @if (active_objective_title_by_company_product_id()[company_product_item.company_product_id]; as objective_title) {
                  <app-truncated-text-marquee class="company-product-active-objective" [text]="objective_title" />
                }
              </div>
              @if (
                pending_bisual_internal_slack_config_by_company_product_id()[company_product_item.company_product_id] ||
                pending_bot_not_member_by_company_product_id()[company_product_item.company_product_id] ||
                pending_unconfigured_applications_by_company_product_id()[company_product_item.company_product_id]
              ) {
                <span class="notification-badge">1</span>
              }
            </a>
          </li>
        }
      }
    } @else {
      @if (single_company_product(); as company_product_item) {
        <li class="menu-first-section-item" [class.active]="isCompanyProductActive(company_product_item.company_product_id)">
          <a
            matRipple
            role="button"
            tabindex="0"
            (click)="goToCompanyProductPhases(company_product_item.company_product_id)"
            (keydown.enter)="goToCompanyProductPhases(company_product_item.company_product_id)"
          >
            <div
              class="company-product-logo"
              [ngStyle]="{ 'background-image': 'url(' + company_product_item.company_product_logo_url + ')' }"
            ></div>
            <div class="company-product-menu-content">
              <span>{{ company_product_item.company_product_name }}</span>
              @if (active_objective_title_by_company_product_id()[company_product_item.company_product_id]; as objective_title) {
                <app-truncated-text-marquee class="company-product-active-objective" [text]="objective_title" />
              }
            </div>
            @if (
              pending_bisual_internal_slack_config_by_company_product_id()[company_product_item.company_product_id] ||
              pending_bot_not_member_by_company_product_id()[company_product_item.company_product_id] ||
              pending_unconfigured_applications_by_company_product_id()[company_product_item.company_product_id]
            ) {
              <span class="notification-badge">1</span>
            }
          </a>
        </li>
      }
    }
  }

  <li
    class="menu-separator menu-accordion-header"
    matRipple
    role="button"
    tabindex="0"
    [class.section-active]="isSectionActive(MenuSectionEnum.ACTIVITY)"
    [attr.aria-expanded]="isSectionExpanded(MenuSectionEnum.ACTIVITY)"
    (click)="toggleSection(MenuSectionEnum.ACTIVITY)"
    (keydown)="onAccordionKeydown($event, MenuSectionEnum.ACTIVITY)"
  >
    <span>Actividad</span>
    <mat-icon class="menu-accordion-chevron" [class.expanded]="isSectionExpanded(MenuSectionEnum.ACTIVITY)">expand_more</mat-icon>
  </li>

  @if (isSectionExpanded(MenuSectionEnum.ACTIVITY)) {
    @if ((employee.meetingModeEnabled | async) === false) {
      <li routerLinkActive="active">
        <a matRipple [routerLink]="['/employees', 'activity', 'history']">
          <mat-icon>app_registration</mat-icon>
          <span>Mi trabajo</span>
        </a>
      </li>
      <li routerLinkActive="active">
        <a matRipple [routerLink]="['/employees', 'activity', 'assisted-meeting-records']">
          <mat-icon>groups</mat-icon>
          <span>Mis reuniones</span>
        </a>
      </li>
    }

    <li routerLinkActive="active">
      <a matRipple [routerLink]="['/employees', 'activity', 'calendar']">
        <mat-icon>calendar_month</mat-icon>
        <span>Calendario</span>
      </a>
    </li>

    @if ((employee.meetingModeEnabled | async) === false) {
      <li routerLinkActive="active">
        <a matRipple [routerLink]="['/employees', 'activity', 'clock-registers']">
          <mat-icon>timer</mat-icon>
          <span>Control horario</span>
        </a>
      </li>
    }
  }

  @if ((employee.meetingModeEnabled | async) === false) {
    <li
      class="menu-separator menu-accordion-header"
      matRipple
      role="button"
      tabindex="0"
      [class.section-active]="isSectionActive(MenuSectionEnum.PERFORMANCE)"
      [attr.aria-expanded]="isSectionExpanded(MenuSectionEnum.PERFORMANCE)"
      (click)="toggleSection(MenuSectionEnum.PERFORMANCE)"
      (keydown)="onAccordionKeydown($event, MenuSectionEnum.PERFORMANCE)"
    >
      <span>Rendimiento</span>
      <mat-icon class="menu-accordion-chevron" [class.expanded]="isSectionExpanded(MenuSectionEnum.PERFORMANCE)">expand_more</mat-icon>
    </li>
    @if (isSectionExpanded(MenuSectionEnum.PERFORMANCE)) {
      <li routerLinkActive="active">
        <a matRipple [routerLink]="['/employees', 'performance', 'metrics']">
          <mat-icon>bar_chart</mat-icon>
          <span>Mis métricas</span>
        </a>
      </li>
      <li routerLinkActive="active">
        <a matRipple [routerLink]="['/employees', 'performance', 'career-plan']">
          <mat-icon>query_stats</mat-icon>
          <span>Mi carrera</span>
        </a>
      </li>
      <li routerLinkActive="active">
        <a matRipple [routerLink]="['/employees', 'performance', 'upskilling']">
          <mat-icon>school</mat-icon>
          <span>Upskilling</span>
        </a>
      </li>
      <li routerLinkActive="active">
        <a matRipple [routerLink]="['/employees', 'performance', 'payrolls']">
          <mat-icon>payments</mat-icon>
          <span>Mi retribución</span>
        </a>
      </li>
    }

    <li
      class="menu-separator menu-accordion-header"
      matRipple
      role="button"
      tabindex="0"
      [class.section-active]="isSectionActive(MenuSectionEnum.PERSONAL)"
      [attr.aria-expanded]="isSectionExpanded(MenuSectionEnum.PERSONAL)"
      (click)="toggleSection(MenuSectionEnum.PERSONAL)"
      (keydown)="onAccordionKeydown($event, MenuSectionEnum.PERSONAL)"
    >
      <span>Gestiones</span>
      <mat-icon class="menu-accordion-chevron" [class.expanded]="isSectionExpanded(MenuSectionEnum.PERSONAL)">expand_more</mat-icon>
    </li>

    @if (isSectionExpanded(MenuSectionEnum.PERSONAL)) {
      <li routerLinkActive="active">
        <a matRipple [routerLink]="['/employees', 'personal', 'working-extra-hours-periods']">
          <mat-icon>more_time</mat-icon>
          <span>Horas extras</span>
        </a>
      </li>
      <li routerLinkActive="active">
        <a matRipple [routerLink]="['/employees', 'personal', 'absences']">
          <mat-icon>person_off</mat-icon>
          <span>Ausencias</span>
        </a>
      </li>
      <li routerLinkActive="active">
        <a matRipple [routerLink]="['/employees', 'personal', 'my-documents']">
          <mat-icon>insert_drive_file</mat-icon>
          <span>Mis documentos</span>
        </a>
      </li>
      <li routerLinkActive="active">
        <a matRipple [routerLink]="['/employees', 'personal', 'remote-work-exceptions']">
          <mat-icon>home_work</mat-icon>
          <span>Excepciones teletrabajo</span>
        </a>
      </li>
      <li routerLinkActive="active">
        <a matRipple [routerLink]="['/employees', 'personal', 'driving-requests']">
          <mat-icon>directions_car</mat-icon>
          <span>Viajes</span>
        </a>
      </li>
    }

    @if (permissions.isDepartment('direction') || permissions.isDepartment('marketing')) {
      <li
        class="menu-separator menu-accordion-header"
        matRipple
        role="button"
        tabindex="0"
        [class.section-active]="isSectionActive(MenuSectionEnum.MARKETING)"
        [attr.aria-expanded]="isSectionExpanded(MenuSectionEnum.MARKETING)"
        (click)="toggleSection(MenuSectionEnum.MARKETING)"
        (keydown)="onAccordionKeydown($event, MenuSectionEnum.MARKETING)"
      >
        <span>Marketing</span>
        <mat-icon class="menu-accordion-chevron" [class.expanded]="isSectionExpanded(MenuSectionEnum.MARKETING)">expand_more</mat-icon>
      </li>

      @if (isSectionExpanded(MenuSectionEnum.MARKETING)) {
        <li routerLinkActive="active">
          <a matRipple [routerLink]="['/employees', 'marketing', 'blogposts']">
            <mat-icon>rss_feed</mat-icon>
            <span>Blog</span>
          </a>
        </li>
      }
    }

    @if (permissions.isDepartment('direction') || permissions.isDepartment('support')) {
      <li
        class="menu-separator menu-accordion-header"
        matRipple
        role="button"
        tabindex="0"
        [class.section-active]="isSectionActive(MenuSectionEnum.SUPPORT)"
        [attr.aria-expanded]="isSectionExpanded(MenuSectionEnum.SUPPORT)"
        (click)="toggleSection(MenuSectionEnum.SUPPORT)"
        (keydown)="onAccordionKeydown($event, MenuSectionEnum.SUPPORT)"
      >
        <span>Soporte</span>
        <mat-icon class="menu-accordion-chevron" [class.expanded]="isSectionExpanded(MenuSectionEnum.SUPPORT)">expand_more</mat-icon>
      </li>

      @if (isSectionExpanded(MenuSectionEnum.SUPPORT)) {
        <li routerLinkActive="active">
          <a matRipple [routerLink]="['/employees', 'support', 'tickets']">
            <mat-icon>support_agent</mat-icon>
            <span>Tickets</span>
          </a>
        </li>
      }
    }

    @if (canSeeRrhhMenu()) {
      <li
        class="menu-separator menu-accordion-header"
        matRipple
        role="button"
        tabindex="0"
        [class.section-active]="isSectionActive(MenuSectionEnum.RRHH)"
        [attr.aria-expanded]="isSectionExpanded(MenuSectionEnum.RRHH)"
        (click)="toggleSection(MenuSectionEnum.RRHH)"
        (keydown)="onAccordionKeydown($event, MenuSectionEnum.RRHH)"
      >
        <span class="menu-accordion-title">
          RRHH
          @if (!isSectionExpanded(MenuSectionEnum.RRHH) && pending_rrhh_actions_count() > 0) {
            <span class="notification-badge">{{ pending_rrhh_actions_count() }}</span>
          }
        </span>
        <mat-icon class="menu-accordion-chevron" [class.expanded]="isSectionExpanded(MenuSectionEnum.RRHH)">expand_more</mat-icon>
      </li>

      @if (isSectionExpanded(MenuSectionEnum.RRHH)) {
        @if (canSeeRrhhSection()) {
          <li routerLinkActive="active">
            <a matRipple [routerLink]="['/employees', 'rrhh', 'workers']">
              <mat-icon>group</mat-icon>
              <span>Trabajadores</span>
            </a>
          </li>
          <li routerLinkActive="active">
            <a matRipple [routerLink]="['/employees', 'rrhh', 'absences-management']">
              <mat-icon>flight_takeoff</mat-icon>
              <span>Gestión de ausencias</span>
              @if (pendingAbsenceRequestsCount() > 0) {
                <span class="notification-badge">{{ pendingAbsenceRequestsCount() }}</span>
              }
            </a>
          </li>
          <li routerLinkActive="active">
            <a matRipple [routerLink]="['/employees', 'rrhh', 'clock-register-review-requests']">
              <mat-icon>timer</mat-icon>
              <span>Gestión de fichajes</span>
              @if (pendingScheduleChangeRequestsCount() > 0) {
                <span class="notification-badge">{{ pendingScheduleChangeRequestsCount() }}</span>
              }
            </a>
          </li>
          <li routerLinkActive="active">
            <a matRipple [routerLink]="['/employees', 'rrhh', 'working-contract-weekly-schedule-exception-requests']">
              <mat-icon>edit_calendar</mat-icon>
              <span>Cambios de horario</span>
              @if (pending_weekly_schedule_exception_requests_count() > 0) {
                <span class="notification-badge">{{ pending_weekly_schedule_exception_requests_count() }}</span>
              }
            </a>
          </li>
        }

        @if (canSeeRrhhDrivingMenuItem()) {
          <li routerLinkActive="active">
            <a matRipple [routerLink]="['/employees', 'rrhh', 'driving-requests']">
              <mat-icon>directions_car</mat-icon>
              <span>Peticiones de viaje</span>
              @if (pendingDrivingRequestsCount() > 0) {
                <span class="notification-badge">{{ pendingDrivingRequestsCount() }}</span>
              }
            </a>
          </li>
        }

        @if (canSeeRrhhExtraHoursMenuItem()) {
          <li routerLinkActive="active">
            <a matRipple [routerLink]="['/employees', 'rrhh', 'working-extra-hours-periods']">
              <mat-icon>more_time</mat-icon>
              @if (canSeeRrhhExtraHoursAsResponsible()) {
                <span>Peticiones de horas extra</span>
              } @else {
                <span>Horas extras</span>
              }
              @if (pendingExtraHoursRequestsCount() > 0) {
                <span class="notification-badge">{{ pendingExtraHoursRequestsCount() }}</span>
              }
            </a>
          </li>
        }

        @if (canSeeRrhhRemoteWorkMenuItem()) {
          <li routerLinkActive="active">
            <a matRipple [routerLink]="['/employees', 'rrhh', 'remote-work-management']">
              <mat-icon>add_home_work</mat-icon>
              @if (canSeeRrhhRemoteWorkAsResponsible()) {
                <span>Peticiones de teletrabajo</span>
              } @else {
                <span>Gestión de teletrabajo</span>
              }
              @if (pendingRemoteWorkRequestsCount() > 0) {
                <span class="notification-badge">{{ pendingRemoteWorkRequestsCount() }}</span>
              }
            </a>
          </li>
        }

        @if (canSeeRrhhSection()) {
          <li routerLinkActive="active">
            <a matRipple [routerLink]="['/employees', 'rrhh', 'payrolls']">
              <mat-icon>request_quote</mat-icon>
              <span>Nóminas</span>
            </a>
          </li>
          <li routerLinkActive="active">
            <a matRipple [routerLink]="['/employees', 'rrhh', 'departments']">
              <mat-icon>supervised_user_circle</mat-icon>
              <span>Departamentos</span>
            </a>
          </li>
          <li routerLinkActive="active">
            <a matRipple [routerLink]="['/employees', 'rrhh', 'holidays']">
              <mat-icon>event_upcoming</mat-icon>
              <span>Festividades</span>
            </a>
          </li>
          <li routerLinkActive="active">
            <a matRipple [routerLink]="['/employees', 'rrhh', 'locations']">
              <mat-icon>place</mat-icon>
              <span>Ubicaciones</span>
            </a>
          </li>
          <li routerLinkActive="active">
            <a matRipple [routerLink]="['/employees', 'rrhh', 'computers']">
              <mat-icon>computer</mat-icon>
              <span>Ordenadores</span>
            </a>
          </li>
          <li routerLinkActive="active">
            <a matRipple [routerLink]="['/employees', 'rrhh', 'learning-resource-requests']">
              <mat-icon>school</mat-icon>
              <span>Solicitudes de formación</span>
              @if (pendingLearningResourceRequestsCount() > 0) {
                <span class="notification-badge">{{ pendingLearningResourceRequestsCount() }}</span>
              }
            </a>
          </li>
          <li routerLinkActive="active">
            <a matRipple [routerLink]="['/employees', 'rrhh', 'surveys']">
              <mat-icon>local_post_office</mat-icon>
              <span>Encuestas</span>
            </a>
          </li>
          <li routerLinkActive="active">
            <a matRipple [routerLink]="['/employees', 'rrhh', 'formations']">
              <mat-icon>menu_book</mat-icon>
              <span>Formaciones</span>
            </a>
          </li>
          <li routerLinkActive="active">
            <a matRipple [routerLink]="['/employees', 'rrhh', 'job-vacancies']">
              <mat-icon>work</mat-icon>
              <span>Vacantes</span>
            </a>
          </li>
          <li [class.active]="isExamsSectionActive()">
            <a matRipple [routerLink]="['/employees', 'rrhh', 'exam-instances']">
              <mat-icon>assignment</mat-icon>
              <span>Exámenes</span>
            </a>
          </li>
          <li routerLinkActive="active">
            <a matRipple [routerLink]="['/employees', 'rrhh', 'skills']">
              <mat-icon>psychology</mat-icon>
              <span>Skills</span>
            </a>
          </li>
          <li routerLinkActive="active">
            <a matRipple [routerLink]="['/employees', 'rrhh', 'document-types']">
              <mat-icon>category</mat-icon>
              <span>Tipos de documentos</span>
            </a>
          </li>
        }
      }
    }
  }

  @if ((employee.meetingModeEnabled | async) === false || (employee.meetingModeCompanyProduct | async) === null) {
    @if (permissions.isDepartment('direction') || permissions.isDepartment('comercial')) {
      <li
        class="menu-separator menu-accordion-header"
        matRipple
        role="button"
        tabindex="0"
        [class.section-active]="isSectionActive(MenuSectionEnum.COMERCIAL)"
        [attr.aria-expanded]="isSectionExpanded(MenuSectionEnum.COMERCIAL)"
        (click)="toggleSection(MenuSectionEnum.COMERCIAL)"
        (keydown)="onAccordionKeydown($event, MenuSectionEnum.COMERCIAL)"
      >
        <span class="menu-accordion-title">
          Comercial
          @if (!isSectionExpanded(MenuSectionEnum.COMERCIAL) && pendingPotentialClientsToContactCount() > 0) {
            <span class="notification-badge">{{ pendingPotentialClientsToContactCount() }}</span>
          }
        </span>
        <mat-icon class="menu-accordion-chevron" [class.expanded]="isSectionExpanded(MenuSectionEnum.COMERCIAL)">expand_more</mat-icon>
      </li>

      @if (isSectionExpanded(MenuSectionEnum.COMERCIAL)) {
        @if (permissions.isDepartment('direction')) {
          <li routerLinkActive="active">
            <a matRipple [routerLink]="['/employees', 'comercial', 'dashboard']">
              <mat-icon>insights</mat-icon>
              <span>Dashboard & KPIs</span>
            </a>
          </li>
          <li routerLinkActive="active">
            <a matRipple [routerLink]="['/employees', 'comercial', 'lead-assignment']">
              <mat-icon>percent</mat-icon>
              <span>Asignación leads Meta</span>
            </a>
          </li>
        }

        <li routerLinkActive="active">
          <a matRipple [routerLink]="['/employees', 'comercial', 'potential-clients']">
            <mat-icon>emoji_people</mat-icon>
            <span>Clientes potenciales</span>
            @if (pendingPotentialClientsToContactCount() > 0) {
              <span class="notification-badge">{{ pendingPotentialClientsToContactCount() }}</span>
            }
          </a>
        </li>
      }
    }
  }

  @if ((employee.meetingModeEnabled | async) === false) {
    @if (permissions.isDepartment('direction')) {
      <li
        class="menu-separator menu-accordion-header"
        matRipple
        role="button"
        tabindex="0"
        [class.section-active]="isSectionActive(MenuSectionEnum.PRODUCTION)"
        [attr.aria-expanded]="isSectionExpanded(MenuSectionEnum.PRODUCTION)"
        (click)="toggleSection(MenuSectionEnum.PRODUCTION)"
        (keydown)="onAccordionKeydown($event, MenuSectionEnum.PRODUCTION)"
      >
        <span class="menu-accordion-title">
          Producción
          @if (!isSectionExpanded(MenuSectionEnum.PRODUCTION) && pending_production_actions_count() > 0) {
            <span class="notification-badge">{{ pending_production_actions_count() }}</span>
          }
        </span>
        <mat-icon class="menu-accordion-chevron" [class.expanded]="isSectionExpanded(MenuSectionEnum.PRODUCTION)">expand_more</mat-icon>
      </li>

      @if (isSectionExpanded(MenuSectionEnum.PRODUCTION)) {
        <li routerLinkActive="active">
          <a matRipple [routerLink]="['/employees', 'production', 'company-products']">
            <mat-icon>apps</mat-icon>
            <span>Gestión de productos</span>
          </a>
        </li>
        <li routerLinkActive="active">
          <a matRipple [routerLink]="['/employees', 'production', 'production-planification']">
            <mat-icon>view_timeline</mat-icon>
            <span>Planificación productiva</span>
          </a>
        </li>
        <li routerLinkActive="active">
          <a matRipple [routerLink]="['/employees', 'production', 'metrics']">
            <mat-icon>bar_chart</mat-icon>
            <span>Métricas</span>
          </a>
        </li>
        <li routerLinkActive="active">
          <a matRipple [routerLink]="['/employees', 'production', 'company-product-monthly-economic-reports']">
            <mat-icon>receipt_long</mat-icon>
            <span>Facturas de productos</span>
            @if (pending_invoice_conciliations_count() > 0) {
              <span class="notification-badge">{{ pending_invoice_conciliations_count() }}</span>
            }
          </a>
        </li>
      }

      <li
        class="menu-separator menu-accordion-header"
        matRipple
        role="button"
        tabindex="0"
        [class.section-active]="isSectionActive(MenuSectionEnum.CONFIGURATION)"
        [attr.aria-expanded]="isSectionExpanded(MenuSectionEnum.CONFIGURATION)"
        (click)="toggleSection(MenuSectionEnum.CONFIGURATION)"
        (keydown)="onAccordionKeydown($event, MenuSectionEnum.CONFIGURATION)"
      >
        <span class="menu-accordion-title">
          Configuración
          @if (!isSectionExpanded(MenuSectionEnum.CONFIGURATION) && pending_configuration_actions_count() > 0) {
            <span class="notification-badge">{{ pending_configuration_actions_count() }}</span>
          }
        </span>
        <mat-icon class="menu-accordion-chevron" [class.expanded]="isSectionExpanded(MenuSectionEnum.CONFIGURATION)">expand_more</mat-icon>
      </li>

      @if (isSectionExpanded(MenuSectionEnum.CONFIGURATION)) {
        <li routerLinkActive="active">
          <a matRipple [routerLink]="['/employees', 'configuration', 'messaging-conversations']">
            <mat-icon>forum</mat-icon>
            <span>Conversaciones</span>
            @if (pending_unassigned_messaging_conversations_count() > 0) {
              <span class="notification-badge">{{ pending_unassigned_messaging_conversations_count() }}</span>
            }
          </a>
        </li>
        <li routerLinkActive="active">
          <a matRipple [routerLink]="['/employees', 'configuration', 'workspaces']">
            <mat-icon>hub</mat-icon>
            <span>Workspaces</span>
            @if (pending_unassigned_workspaces_count() > 0) {
              <span class="notification-badge">{{ pending_unassigned_workspaces_count() }}</span>
            }
          </a>
        </li>
        <li routerLinkActive="active">
          <a matRipple [routerLink]="['/employees', 'configuration', 'bisual']">
            <mat-icon>settings</mat-icon>
            <span>Configuración de Bisual</span>
          </a>
        </li>
      }

      <li
        class="menu-separator menu-accordion-header"
        matRipple
        role="button"
        tabindex="0"
        [class.section-active]="isSectionActive(MenuSectionEnum.DIRECTION)"
        [attr.aria-expanded]="isSectionExpanded(MenuSectionEnum.DIRECTION)"
        (click)="toggleSection(MenuSectionEnum.DIRECTION)"
        (keydown)="onAccordionKeydown($event, MenuSectionEnum.DIRECTION)"
      >
        <span class="menu-accordion-title">Dirección</span>
        <mat-icon class="menu-accordion-chevron" [class.expanded]="isSectionExpanded(MenuSectionEnum.DIRECTION)">expand_more</mat-icon>
      </li>

      @if (isSectionExpanded(MenuSectionEnum.DIRECTION)) {
        <li routerLinkActive="active">
          <a matRipple [routerLink]="['/employees', 'direction', 'users']">
            <mat-icon>manage_accounts</mat-icon>
            <span>Usuarios</span>
          </a>
        </li>
        <li routerLinkActive="active">
          <a matRipple [routerLink]="['/employees', 'direction', 'companies']">
            <mat-icon>business</mat-icon>
            <span>Empresas</span>
          </a>
        </li>
        <li routerLinkActive="active">
          <a matRipple [routerLink]="['/employees', 'direction', 'providers']">
            <mat-icon>local_shipping</mat-icon>
            <span>Proveedores</span>
          </a>
        </li>
        <li routerLinkActive="active">
          <a matRipple [routerLink]="['/employees', 'direction', 'legal']">
            <mat-icon>policy</mat-icon>
            <span>Documentación legal</span>
          </a>
        </li>
      }
    }
  }

  <li
    class="menu-separator menu-accordion-header"
    matRipple
    role="button"
    tabindex="0"
    [class.section-active]="isSectionActive(MenuSectionEnum.INFO)"
    [attr.aria-expanded]="isSectionExpanded(MenuSectionEnum.INFO)"
    (click)="toggleSection(MenuSectionEnum.INFO)"
    (keydown)="onAccordionKeydown($event, MenuSectionEnum.INFO)"
  >
    <span>Información de interés</span>
    <mat-icon class="menu-accordion-chevron" [class.expanded]="isSectionExpanded(MenuSectionEnum.INFO)">expand_more</mat-icon>
  </li>

  @if (isSectionExpanded(MenuSectionEnum.INFO)) {
    <li routerLinkActive="active">
      <a matRipple [routerLink]="['/employees', 'wiki']">
        <mat-icon>import_contacts</mat-icon>
        <span>Wiki</span>
      </a>
    </li>
  }
</ul>
